export default "__VITE_ASSET__Byd7V7bn__"